// Curated list of common BCP 47 language tags accepted by the backend (validated via .NET CultureInfo).
export const LOCALE_CODES: string[] = [
  "af",
  "sq",
  "am",
  "ar-SA",
  "ar-EG",
  "ar-AE",
  "ar-MA",
  "hy",
  "az",
  "eu",
  "be",
  "bn-BD",
  "bn-IN",
  "bs",
  "bg-BG",
  "ca",
  "zh-CN",
  "zh-TW",
  "zh-HK",
  "hr-HR",
  "cs-CZ",
  "da-DK",
  "nl-NL",
  "nl-BE",
  "en-US",
  "en-GB",
  "en-AU",
  "en-CA",
  "en-IN",
  "en-NZ",
  "en-ZA",
  "et",
  "fo",
  "fi-FI",
  "fr-FR",
  "fr-CA",
  "fr-BE",
  "fr-CH",
  "gl",
  "ka",
  "de-DE",
  "de-AT",
  "de-CH",
  "el-GR",
  "gu",
  "he-IL",
  "hi-IN",
  "hu-HU",
  "is",
  "id-ID",
  "ga",
  "it-IT",
  "it-CH",
  "ja-JP",
  "kn",
  "kk",
  "km",
  "ko-KR",
  "lv",
  "lt",
  "lb",
  "mk",
  "ms-MY",
  "ml-IN",
  "mt",
  "mr",
  "mn",
  "ne",
  "nb-NO",
  "nn-NO",
  "fa-IR",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "pa",
  "ro-RO",
  "ru-RU",
  "sr-RS",
  "sk-SK",
  "sl-SI",
  "es-ES",
  "es-MX",
  "es-AR",
  "es-CO",
  "es-CL",
  "es-US",
  "sw",
  "sv-SE",
  "ta-IN",
  "te-IN",
  "th-TH",
  "tr-TR",
  "uk-UA",
  "ur-PK",
  "uz",
  "vi-VN",
  "cy",
  "zu",
]
